import React, { Component } from "react";
import PropTypes from "prop-types";
import withTranslation from "../translation";
import styles from "./Burger.css";

class Burger extends Component {
  constructor(props) {
    super(props);
    this.openSidePanel = this.openSidePanel.bind(this);
  }
  static propTypes = {
    openSidePanel: PropTypes.func.isRequired,
    isSidePanelOpen: PropTypes.bool.isRequired,
    isSearchVisible: PropTypes.bool.isRequired,
    formatTranslation: PropTypes.func.isRequired,
    addLastFocusElement: PropTypes.func.isRequired
  };

  saveRef = component => (this.component = component);

  openSidePanel() {
    this.props.openSidePanel();
    this.props.addLastFocusElement("[data-testid='burger-menu-button']");
  }

  render() {
    const { formatTranslation } = this.props;
    return (
      <button
        className={styles.burger}
        onClick={this.openSidePanel}
        ref={this.saveRef}
        aria-label={formatTranslation("burger_open_navigation_label")}
        tabIndex={this.props.isSidePanelOpen ? -1 : 0}
        data-testid="burger-menu-button"
      />
    );
  }
}

export default withTranslation(Burger);
